import { createTokens } from "../utils";
export var sizing = createTokens('vm-sizing', {
    sizeSpaceXXS: '2px',
    sizeSpaceXS: '4px',
    sizeSpaceS: '8px',
    sizeSpaceM: '16px',
    sizeSpaceL: '24px',
    sizeSpaceXL: '32px',
    sizeSpaceXXL: '48px',
    sizeSpaceXXXL: '64x',
    sizeFieldXXS: '80px',
    sizeFieldXS: '128px',
    sizeFieldS: '176px',
    sizeFieldM: '272px',
    sizeFieldL: '368px',
    sizeFieldXL: '464px',
    sizeFieldXXL: '560px',
    sizeDialogWidthXXS: '288px',
    sizeDialogWidthXS: '480px',
    sizeDialogWidthS: '600px',
    sizeDialogWidthM: '720px',
    sizeDialogWidthL: '800px',
    sizeDialogWidthXL: '880px',
    sizeDialogWidthXXL: '960px',
    sizeDialogHeightXXS: '160px',
    sizeDialogHeightXS: '260px',
    sizeDialogHeightS: '320px',
    sizeDialogHeightM: '400px',
    sizeDialogHeightL: '432px',
    sizeDialogHeightXL: '560px',
    sizeDialogHeightXXL: '700px'
});
//# sourceMappingURL=sizing.js.map